import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { formikRef } from "../../store/formikStore/formikStore";
import { setBuildingPermitModals } from "../../store/actions/permitFormActions/modalControlStateActions";
import { handleBondingRemove } from "../permitPackageFunctions/savedProjectsFunctions";

const RemoveBondingModal = () => {
  const formik = formikRef.current;
  const { addingNewBonding } = useSelector((state) => state.buildingState);

  const { bondingConfirmModalOpen } = useSelector(
    (state) => state.modalControlState.buildingPermit
  );
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setBuildingPermitModals({ bondingConfirmModalOpen: false }));
  };

  const handleConfirm = () => {
    handleBondingRemove(formik?.values, formik?.setValues, dispatch);
  };

  return (
    <Modal
      open={bondingConfirmModalOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "transparent",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          //   border: "2px solid #000",
          boxShadow: 2,
          p: 4,
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2">
          {addingNewBonding
            ? "Cancel the addition of a new bonding company details"
            : "Confirm the removal of the new bonding company details"}
        </Typography>
        <Typography id="modal-description" sx={{ mt: 2 }}>
          {addingNewBonding
            ? "Would you like to cancel the addition of a new bonding company details?"
            : "Would you like to remove this bonding company details from your list?"}
        </Typography>
        <Box
          sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button color="error" onClick={handleConfirm} sx={{ ml: 2 }}>
            Confirm
          </Button>
          <Button variant="contained" onClick={handleClose} color="primary">
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default React.memo(RemoveBondingModal);
